// extracted by mini-css-extract-plugin
export default {"table":"Table_table__WQpHp","link":"Table_link__N3EUs","buttonLink":"Table_buttonLink__CFhXV","linkIcon":"Table_linkIcon__UCVmO"};